import { EventTypes } from "./events";

class EventMapping {
  private moduleName: string;

  constructor(moduleName: string) {
    // console.log('model name',moduleName);
    
    this.moduleName = moduleName.toUpperCase();
  }


  getEvent(inputEvent: EventTypes,finalModuleName?:string): EventTypes {
    // console.log('input event in getevent fun',inputEvent);

    if (!inputEvent) {
      console.warn(`Invalid event object: ${inputEvent}`);
    }
    let module=this.moduleName;
    if(finalModuleName){
      module = finalModuleName.toUpperCase();
    }

    return {
      category: `${module} ${inputEvent.category}`,
      action: `${module} ${inputEvent.action}`,
      label: inputEvent.label,
    };
  }

  getEventError(inputEvent: EventTypes,eventLabel:string,finalModuleName?:string): EventTypes {
    // console.log('input event in getevent fun',inputEvent);

    if (!inputEvent) {
      console.warn(`Invalid event object: ${inputEvent}`);
    }

    let module=this.moduleName;
    if(finalModuleName){
      module = finalModuleName.toUpperCase();
    }

    return {
      category: `${module} ${inputEvent.category}`,
      action: `Error: ${module} ${inputEvent.action}`,
      label: eventLabel?eventLabel:inputEvent.label,
    };
  }
}

export default EventMapping;
